const reThousandBoundry = /\B(?=(\d{3})+(?!\d))/g;
const currencySymbol = '$';
/**
 * Given a currency `amount` as dollars (not cents!), returns a string with
 * a $-sign prepended, thousand separators and fixed 2-decimal
 * representation of your number.
 *
 * Negative numbers are handled in "accounting notation" and get surrounded
 * by brackets.
 *
 * Note that we are indeed storing dollar amount as "floats" (A JS `Number`
 * is a regular IEEE-float under the hood). We do few if any calculations on
 * the client side and it's impractical to switch to cent-counts at this point.
 */

export default function formatCurrency(amount: number): string {
  const absAmount = currencySymbol + Math.abs(amount).toFixed(2).replace(reThousandBoundry, ',');

  if (amount < 0) {
    return `(${absAmount})`;
  }

  return absAmount;
}
